function p(s, r, i = [s]) {
  const u = s.joints[0].bones.find((f) => f !== s && f.floors > r && !i.includes(f)), t = s.joints[1].bones.find((f) => f !== s && f.floors > r && !i.includes(f));
  return u && (i.push(u), p(u, r, i)), t && (i.push(t), p(t, r, i)), i;
}
export {
  p as getConnectedBonesAtLevel
};
//# sourceMappingURL=index.js.map
